import { dsClass } from '../../../common/constants/dsClasses.js';
import { paths } from '../../../common/constants/pathVariables.js';
import { CommonErrorType, DialogType } from '../../../common/enums.js';
import { closeMsg, dialogSystemErrorHeaderMsg, t } from '../../../common/i18n/index.js';
import { CreditCheckDecision } from '../../../generated/api/models.js';
import { useDialog } from '../../../public/site/DialogProvider.js';
import { closeDialog } from '../../../public/site/dialogStore.js';
import { DialogWrapper } from '../../DialogWrapper/index.js';

export const PunchoutCheckoutDialog = () => {
  const dialog = useDialog();
  const errors = dialog?.errors;
  const onCloseDialog = () => closeDialog();

  if (errors && errors.length > 0) {
    const dialogError = errors[0];
    const headerText =
      dialogError.type === CommonErrorType.SYSTEM
        ? t.V0VJ(dialogSystemErrorHeaderMsg)
        : t.ZK30('Order confirmation failed');

    const pdfLink =
      dialogError.category === CreditCheckDecision.EMPLOYEE_NEGATIVE_CREDIT_DECISION &&
      t.KA37('https://elisa.fi/attachment/content/Elisa_Yleiset_sopimusehdot_ENG.pdf');

    return (
      <DialogWrapper
        closeable
        header={headerText}
        links={[
          {
            href: paths.PUNCHOUT_STORE,
            text: t.PLAW('Return to the shop'),
          },
        ]}
        onCloseDialog={onCloseDialog}
      >
        <p>
          {dialogError.message}
          {pdfLink && (
            <>
              <a href={pdfLink} target="_blank" rel="noreferrer">
                {` ${t.Z3L0('More information')}`}
              </a>
            </>
          )}
        </p>
      </DialogWrapper>
    );
  }
  if (dialog?.params?.type) {
    switch (dialog.params.type) {
      case DialogType.GENERIC_INFO_DIALOG:
        return (
          <DialogWrapper
            buttons={[
              {
                onClick: onCloseDialog,
                text: t.WOYD(closeMsg),
              },
            ]}
            header={dialog.params.header}
            onCloseDialog={onCloseDialog}
          >
            <div className={dsClass.PADDING_TOP_4}>{dialog.params.body}</div>
          </DialogWrapper>
        );
    }
  }
  return null;
};
